"use strict";

var _slicedToArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query FileManagementProvider {\n    system {\n      environmentSettings {\n        fileManagementProvider\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileInput = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importStar(require("react"));

var graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));

var react_apollo_1 = require("react-apollo");

var FileInput_aws_1 = require("./FileInput.aws");

var FileInput_filestack_1 = require("./FileInput.filestack");

var FALLBACK_PROPS = {
  value: null,
  originalFile: null,
  error: null,
  loading: true
};
var FILE_MANAGEMENT_PROVIDER_QUERY = (0, graphql_tag_1.default)(_templateObject());
var AWS_PROVIDER_NAME = 'aws';

var checkAWSProvider = function checkAWSProvider(data) {
  var provider = data && data.system && data.system.environmentSettings && data.system.environmentSettings.fileManagementProvider;
  return provider === AWS_PROVIDER_NAME;
};
/**
 * This component check the workspace file provider
 * and selects which type of filepicker to use - filestack or 8base
 */


var FileInput = function FileInput(props) {
  // need to open picker after finish query
  var _ref = (0, react_1.useState)(),
      _ref2 = _slicedToArray(_ref, 2),
      fallbackOptions = _ref2[0],
      setFallbackOptions = _ref2[1];

  var _ref3 = (0, react_apollo_1.useQuery)(FILE_MANAGEMENT_PROVIDER_QUERY, {
    fetchPolicy: props.fetchPolicy
  }),
      data = _ref3.data,
      loading = _ref3.loading;

  if (loading) {
    return props.children(Object.assign(Object.assign({}, FALLBACK_PROPS), {
      pick: setFallbackOptions
    }));
  }

  if (!props.useFilestack) {
    return react_1.default.createElement(FileInput_aws_1.FileInputAws, Object.assign({}, props, {
      fallbackOptions: fallbackOptions
    }));
  }

  return react_1.default.createElement(FileInput_filestack_1.FileInputFilestack, Object.assign({}, props, {
    fallbackOptions: fallbackOptions
  }));
};

exports.FileInput = FileInput;